import cn from "classnames"
import React from "react"
import { useSelector } from "swiipe.portal.shared"
import { translationSelectors } from "../../../store/reducers/translationSlice"
import { ITranslationItem } from "../../../type/translations/ITranslationItem"
import "./TranslationChangesBadge.scss"

interface ITranslationChangesBadgeProps {
    items: ITranslationItem[]
    className?: string
}

const TranslationChangesBadge = ({ items, className }: ITranslationChangesBadgeProps) => {
    const changes = useSelector(translationSelectors.changes)
    const currentLanguage = useSelector(translationSelectors.currentLanguage)
    const languageConfigs = useSelector(translationSelectors.languageConfigs)

    const shortLanguage = languageConfigs?.find((l) => l.language === currentLanguage)?.shortCulture ?? currentLanguage
    const relevantChanges = changes.filter((c) => items.some((i) => i.id === c.itemId))
    const changesItems = items.filter((i) => relevantChanges.some((c) => c.itemId === i.id))
    const numChangesLanguage = changesItems.filter((i) =>
        changes.some((c) => c.itemId === i.id && c.language === currentLanguage)
    ).length

    const numRelevantChanges = relevantChanges.length
    if (numRelevantChanges === 0) {
        return null
    }

    return (
        <div className={cn("translation-changes-badge", className)}>
            <div className={cn("translation-changes-badge__container")}>
                <div className={cn("translation-changes-badge__language")}>
                    {shortLanguage}: {numChangesLanguage}
                </div>
                <div className={cn("translation-changes-badge__divider")}></div>
                <div className={cn("translation-changes-badge__type")}>keys: {changesItems.length}</div>
                <div className={cn("translation-changes-badge__divider")}></div>
                <div className={cn("translation-changes-badge__all")}>all: {numRelevantChanges}</div>
            </div>
        </div>
    )
}

export default React.memo(TranslationChangesBadge)
